export default () => ({
	profile: {},
	error: null,
});
